import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// FullCalendar (Batch 2) can trigger a benign "ResizeObserver loop" notice during
// view renders; swallow it so it never surfaces as a runtime-error overlay.
window.addEventListener("error", (e) => {
  if (typeof e?.message === "string" && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

import { initAppUpdates } from "@/lib/appUpdate";

initAppUpdates();
